import { render, staticRenderFns } from "./ModalCentral.vue?vue&type=template&id=17a2959b&scoped=true&"
import script from "./ModalCentral.vue?vue&type=script&lang=js&"
export * from "./ModalCentral.vue?vue&type=script&lang=js&"
import style0 from "./ModalCentral.vue?vue&type=style&index=0&id=17a2959b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a2959b",
  null
  
)

export default component.exports